// extracted by mini-css-extract-plugin
export default {"cta":"App_cta__jUKnT","logo":"App_logo__7Edbg"};